import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";
import { Checkbox } from "@mui/material";

import { useForm } from "../../../../Hooks/useForm";
import { toastShow } from "../../../../Services/ToastService";
import AutoCompleteDropdown from "../../../../Components/Form/AutoCompleteDropdown";
import Loader from "../../../../Components/Loader/Loader";
import { AuthContext } from "../../../../Context/AuthContext/AuthContext";

import { EditarPermisoGeneral, GuardarPermisoGeneral, getPermisosGenerales } from "../../../../API/Global/PermisosGenerales/PermisosGeneralesRequest";
import { getTypesCat } from "../../../../API/Global/Types/TypeRequest";


const PermisosGeneralesCrud = ({
    selected,
    showDialog,
    setShowDialog,
    toastRef,
    getInfo,
    modo,
}) => {

  const toastDialog = useRef(null);
  const toast = useRef(null);

  const [show, setShow] = useState(false);
  const [permisosList, setPermisosList] = useState([{}]);
  const [tipos, setTipos] = useState([{}]);
  const { userAuth } = useContext(AuthContext);
  
  const [loading, setLoading] = useState(false);

  const initialValues = {
    IdPermisoGeneral: selected?.IdPermisoGeneral ? selected?.IdPermisoGeneral : -1,
    NombrePermiso: "",
    Estado: false,
    IdTipo: null,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true)
    const a = await getPermisosGenerales();
    const t = await getTypesCat();
    setTipos(t)

    setPermisosList(a);
    setValues({
        ...selected,
        // IdPermisoGeneral: -100,
        Tipo: t.find(
          (e) => selected?.IdTipo === e.IdType
        ),
    })
    setValues((prevValues) => ({
      ...prevValues,
      Estado: prevValues.Estado || false
    }));
    setLoading(false)
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setShow(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.NombrePermiso) {
      error.NombrePermiso = true;
      error.error = true;
    }
    if (!values.Tipo || !values.Tipo.IdType) {
      error.IdTipo = true;
      error.error = true;
    }
    setError(error);
    // console.log(error);
    return error;
  };

  const agregarPermiso = async () => {
    const e = verificarInfo();
  
    if (!e.error) {
      const existingType = permisosList.find((cur) => cur.NombrePermiso === values?.NombrePermiso &&  cur?.IdTipo === values?.Tipo?.IdType);

      if (existingType && modo === "Crear") {
        toastShow(
          toast,
          "error",
          "Error",
          "Ya existe un Permiso General con ese nombre"
        );
      } else {;
        const Datos = {
          IdPermisoGeneral: values?.IdPermisoGeneral,
          NombrePermiso: values?.NombrePermiso,
          Estado: values?.Estado,
          IdTipo: values.Tipo?.IdType,
          Descripcion: values?.Descripcion,
          IdUserCreate: userAuth?.IdUser,
          FechaCreate: new Date()
        };
  
        if (Datos.IdPermisoGeneral > 0) {
          const resultado = await EditarPermisoGeneral(Datos);
          if (resultado[0]?.ESTADO !== -1) {
            setLoading(true);
            toastShow(toast, "success", "Guardado", resultado[0].MENSAJE);
            getInfo();
            setTimeout(() => {
              onHide();
              setLoading(false);
            }, 1500);
          } else {
            toastShow(toast, "error", "Error al guardar", resultado[0].MENSAJE);
            setLoading(false);
          }
        } else {
          const resultado = await GuardarPermisoGeneral(Datos);
          if (resultado[0].ESTADO !== -1) {
            toastShow(toast, "success", "Guardado", resultado[0].MENSAJE);
            getInfo();
          } else {
            toastShow(toast, "error", "Error al guardar", resultado[0].MENSAJE);
            setTimeout(() => {
              onHide();
              setLoading(false);
            }, 1500);
          }
        }
      }
    }
  };
  

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          if (modo === "Crear") {
            agregarPermiso();
          } else {
            agregarPermiso();
          }
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Permiso General" : "Modificar Permiso General";

  return (
    <div>
      {/* <Toast ref={toast} style={{ zIndex: 50000 }} /> */}
      <Dialog
        visible={showDialog}
        modal
        className="modal__usuarios"
        footer={DialogFooter}
        onHide={onHide}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <Toast ref={toast} />
          <div className="d-flex align-items-center">
            <h2 className="me-3">{dialogTitle}</h2>
          </div>
          <Toast ref={toastDialog} style={{ zIndex: 50000 }} />
          <ConfirmDialog />

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="NombrePermiso"
                  value={values.NombrePermiso}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                  className={error.NombrePermiso ? "p-invalid" : ""}
                />
                <label htmlFor="NombrePermiso">Nombre Permiso</label>
                {error.NombrePermiso && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 100 }}
                  >
                    Campo requerido.
                  </small>
                )}
              </span>
            </div>

            <div className="field col-6 me-2">
              <span className="p-float-label">
                <AutoCompleteDropdown
                  name={"Tipo"}
                  value={values.Tipo}
                  items={tipos}
                  field={"Type"}
                  label={"Tipo"}
                  handleInputChange={handleInputChange}
                  abelStyle={{
                    color: "gray",
                    textShadow: "0px 0px 1px white",
                  }}
                  className={error.IdTipo ? "p-invalid" : ""}
                />
                {error.IdTipo && (
                  <small
                    className="p-error block"
                    style={{ position: "static", top: 100 }}
                  >
                    Campo requerido.
                  </small>
                )}
              </span>
            </div>
          </div>

          <div className="modal__input-contenedor">
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <InputText
                  name="Descripcion"
                  value={values.Descripcion}
                  onChange={handleInputChange}
                  style={{ width: "100%" }}
                  abelStyle={{ color: "gray", textShadow: "0px 0px 1px white" }}
                />
                <label htmlFor="Descripcion">Descripción</label>
              </span>
            </div>
            <div className="field col-6 me-2">
              <span className="p-float-label">
                <Checkbox
                  checked={values.Estado}
                  onChange={(e) =>
                    setValues({
                      ...values,
                      Estado: e.target.checked,
                    })
                  }
                />
                <label htmlFor="Estado">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Estado
                </label>
              </span>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default PermisosGeneralesCrud;
